const TOKEN_KEY = "token";
const ID_KEY = "id";
const USER_TYPE_KEY = "userType";

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
}

export function getAuthUserId() {
  return localStorage.getItem(ID_KEY) || sessionStorage.getItem(ID_KEY);
}

export function getAuthUserType() {
  return (
    localStorage.getItem(USER_TYPE_KEY) ||
    sessionStorage.getItem(USER_TYPE_KEY) ||
    ""
  );
}

export function isSubAdmin() {
  return getAuthUserType().toUpperCase() === "SUB_ADMIN";
}

export function isAdminRole() {
  const role = getAuthUserType().toUpperCase();
  return role === "SUPER_ADMIN" || role === "ADMIN";
}

export function setAuthSession({ rememberMe, token, userId, userType }) {
  clearAuthSession();
  const storage = rememberMe ? localStorage : sessionStorage;
  if (token) storage.setItem(TOKEN_KEY, token);
  if (userId != null && userId !== "") storage.setItem(ID_KEY, String(userId));
  if (userType) storage.setItem(USER_TYPE_KEY, String(userType));
}

export function clearAuthSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ID_KEY);
  localStorage.removeItem(USER_TYPE_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(ID_KEY);
  sessionStorage.removeItem(USER_TYPE_KEY);
}
